import React from "react";
import { FileExtended } from "../classes/fileExtended";

interface IImagePreviewProps {
  image: FileExtended;
  onClose: Function;
}

class ImagePreview extends React.Component<IImagePreviewProps, any> {
  render() {
    return (
      <div className="relative h-32 w-32">
        <div
          className="w-full h-full rounded cursor-pointer"
          style={{
            backgroundImage: `url(${this.props.image.fileUrl})`,
            backgroundSize: "cover",
          }}
        ></div>
        <button onClick={() => { this.props.onClose() }} className="absolute top-0 right-0 w-6 h-6 bg-red rounded-tr hover:bg-red-light">X</button>
      </div>
    );
  }
}

export default ImagePreview;
